<template>
  <el-button v-if="noPermission" type="primary" @click="showLog">{{ $t('logText') }}</el-button>
  <el-button v-else v-permission="permission" type="primary" @click="showLog">
    {{ $t('logText') }}
  </el-button>
</template>
<script>
export default {
  name: 'BjLogButton',
  props: {
    permission: {
      type: String,
      default: '',
    },
    noPermission: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    api: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'common',
    },
    defaultQuery: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      typeObj: {
        common: 'commonDefault',
        order: 'orderLogDefault',
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    showLog() {
      this.$operateLogs(
        {
          title: `${this.title}${this.$t('logText')}`,
          defaultQuery:
            this.type === 'common'
              ? {
                  recordId: this.id,
                }
              : this.defaultQuery,
          api: this.api,
        },
        this.typeObj[this.type],
      );
    },
  },
};
</script>
